import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbFundLatestHome = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">Indo Zambia Bank to Fund Prospective Home-Owners in the Hills Property Development.</h1>

                <p className="pb-3">On 20th January 2025, Indo Zambia Bank (IZB) signed a memorandum of understanding with The Hills Property Development to revolutionise homeownership opportunities in Zambia. Through this partnership, the two entities will facilitate the development of commercial, retail, and mixed-use properties in Palabana, Chongwe District. This partnership will transform Leopards Hill Road into a hub of modern, aesthetically appealing real estate while integrating best practices in the industry.</p>

                <p className="pb-3">“This partnership allows eligible customers of IZB to access financing for both land intended for property construction and completed properties, and our customers can initiate the purchase process through the bank’s branches and The Hills sales and marketing outlets,” IZB Managing Director Brajesh Kumar Singh said.</p>

                <p className="pb-3">The Hills Chairperson, Mwelwa Chibesakunda, emphasised the significant impact of the partnership, which aims to build over 1,500 homes, helping to reduce Lusaka’s housing deficit. The development will also include essential amenities such as roads, water, electricity, healthcare, and education, creating sustainable and inclusive communities.</p>

                <p className="pb-3">To further support homeownership, IZB has revamped its Indo Home Loan facility, offering flexible repayment terms of up to 300 months and low interest rates tailored to salaried individuals, self-employed business owners, and families. The facility covers home purchases, plot acquisitions, construction, renovations, and refinancing. Additionally, customers can apply for top-up loans to take over or enhance existing home loans, making IZB’s offerings more comprehensive and accessible.</p>

                <p className="pb-3">For more information on Indo Home Loan, please contact us on <a href="tel:8002">8002</a>, email us at <a href="mailto:credit@izb.co.zm">credit@izb.co.zm</a> or visit your nearest Indo Zambia Bank branch to apply today!</p>
      

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-to-Fund-Prospective-Home-1.jpg" alt="" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-to-Fund-Prospective-Home-2.jpg" alt="" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-to-Fund-Prospective-Home-4.jpg" alt="" />
                  </div>
                </Slider>
              </div>
            </div>

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbFundLatestHome;